import * as Core from "@zeller-public/payments-sdk-core";
import { safe } from "pb.safe";
import * as v from "valibot";

import { onRequestCancel } from "./on-request-cancel";
import { onRequestQuery } from "./on-request-query";
import { logger } from "./shared/logger";
import { Debug, Resolve } from "./transport/response";

export * from "./transport/response";
export * from "./on-cancel";

// Only to be used in index.tsx entry-point of bundle.
export function Transport_attach() {
	// webview (injected invocation)
	window.onMessage = onRequest;

	// iframe (window event listener)
	window.addEventListener("message", (event) => {
		// only listen to external messages i.e. from the iframe parent
		if (event.origin !== window.location.origin) {
			onRequest(event.data);
		}
	});

	// microsoft webviews (window event listener)
	window?.chrome?.webview?.addEventListener("message", (event) => {
		onRequest(event.data);
	});
}

export function onRequest(messageUnknown: unknown): void {
	Debug({ message: "handling request" });

	if (typeof messageUnknown !== "string") {
		return void logger.debug("transport: on request unknown", {
			message: messageUnknown,
		});
	}

	const request = safe(() =>
		v.parse(Core.Protocol.Request, JSON.parse(messageUnknown)),
	);
	if (request instanceof Error) {
		logger.error("transport: request error", {
			request: messageUnknown,
			errorName: request.name,
			errorMessage: request.message,
			errorStack: request.stack,
		});

		return void Resolve.Error("Operation Request Invalid");
	} else {
		logger.debug("transport: request", { $type: request.$type });
	}

	if (request.$type === "Query") {
		onRequestQuery(request);
	} else if (request.$type === "Cancel") {
		onRequestCancel();
	}
}
